<script>
    // core components
    import EmpresaView from "../../viewsERP/Empresa.svelte";
  </script>
  
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <EmpresaView />
    </div>
  </div>